import { createBrowserRouter, Navigate } from 'react-router'
import { useCurrentUser } from './auth/AuthProvider.tsx'
import { RequireAuth } from './auth/guards.tsx'
import { defaultPath, MODULES } from './modules/registry.ts'
import { ErrorPage } from './pages/ErrorPage.tsx'
import { LoginPage } from './pages/LoginPage.tsx'
import { NotFoundPage } from './pages/NotFoundPage.tsx'
import { AppShell } from './shell/AppShell.tsx'

function HomeRedirect() {
  return <Navigate to={defaultPath(useCurrentUser())} replace />
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage />, errorElement: <ErrorPage /> },
  {
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomeRedirect /> },
      ...MODULES.map((m) => ({ path: m.basePath, element: m.layout, children: m.routes })),
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
